import angular from 'angular';

import "./values";
import { AddToFormDirective } from "./AddToFormDirective";
import { ClickToEditDirective } from "./ClickToEditDirective";
import { ConvertToNumberDirective } from "./ConvertToNumberDirective";
import { CustomSortDirective } from "./CustomSortDirective";
import { DatePickerDirective } from "./DatePickerDirective";
import { FileReadDirective } from "./FileReadDirective";
import { FilteredListDirective } from "./FilteredListDirective";
import { FocusDirective } from "./FocusDirective";
import { GfcIconDirective } from "./GfcIconDirective";
import { GfcValidationSummaryDirective } from "./GfcValidationSummaryDirective";
import { HasPermissionDirective } from "./HasPermissionDirective";
import { MaterialActiveDirective } from "./MaterialActiveDirective";
import { MaterialDropdownDirective } from "./MaterialDropdownDirective";
import { MaterializeCollapsibleDirective } from "./MaterializeCollapsibleDirective";
import { MaterializeTabsDirective } from "./MaterializeTabsDirective";
import { MaterializeTabSelectDirective } from "./MaterializeTabSelectDirective";
import { MaterialSelectDirective } from "./MaterialSelectDirective";
import { MaterialSidebarDirective } from "./MaterialSidebarDirective";
import { MaterialTextAreaDirective } from "./MaterialTextAreaDirective";
import { MaterialTooltipDirective } from "./MaterialTooltipDirective";
import { ModalContentDirective } from "./ModalContentDirective";
import { ModalDirective } from "./ModalDirective";
import { ModalFooterDirective } from "./ModalFooterDirective";
import { ModalHeaderDirective } from "./ModalHeaderDirective";
import { NoAnimateDirective } from "./NoAnimateDirective";
import { NoBubbleDirective } from "./NoBubbleDirective";
import { NotEmptyDirective } from "./NotEmptyDirective";
import { OnBlurDirective } from "./OnBlurDirective";
import { OpenModalDirective } from "./OpenModalDirective";
import { PageHeaderDirective } from "./PageHeaderDirective";
import { SameAsDirective } from "./SameAsDirective";
import { SetColourDirective } from "./SetColourDirective";
import { ShiftEnterDirective } from "./ShiftEnterDirective";
import { StringToColourDirective } from "./StringToColourDirective";
import { StringToNumberDirective } from "./StringToNumberDirective";
import { SubHeaderDirective } from "./SubHeaderDirective";
import { SubSubHeaderDirective } from "./SubSubHeaderDirective";
import { TableSortDirective } from "./TableSortDirective";
import { UserNameDirective } from "./UserNameDirective";
import { ValidationFocusDirective } from "./ValidationFocusDirective";

angular.module("GFC.directives", ["GFC.constants"])
    .directive("materialSelect", MaterialSelectDirective)
    .directive("materialSidebar", MaterialSidebarDirective)
    .directive("materializeTabs", MaterializeTabsDirective)
    .directive("materializeTabSelect", MaterializeTabSelectDirective)
    .directive("materializeCollapsible", MaterializeCollapsibleDirective)
    .directive("materialDropdown", MaterialDropdownDirective)
    .directive("materialTooltip", MaterialTooltipDirective)
    .directive("materialActive", MaterialActiveDirective)
    .directive("materialTextarea", MaterialTextAreaDirective)
    .directive("datePicker", DatePickerDirective)
    .directive("stringToColour", StringToColourDirective)
    .directive("clickToEdit", ClickToEditDirective)
    .directive("sameAs", SameAsDirective)
    .directive("notEmpty", NotEmptyDirective)
    .directive("validationFocus", ValidationFocusDirective)
    .directive("focus", FocusDirective)
    .directive("addToForm", AddToFormDirective)
    .directive("gfcValidationSummary", GfcValidationSummaryDirective)
    .directive("gfcIcon", GfcIconDirective)
    .directive("openModal", OpenModalDirective)
    .directive('stringToNumber', StringToNumberDirective)
    .directive("noBubble", NoBubbleDirective)
    .directive("fileRead", FileReadDirective)
    .directive('convertToNumber', ConvertToNumberDirective)
    .directive("hasPermission", HasPermissionDirective)
    .directive("onBlur", OnBlurDirective)
    .directive("tableSort", TableSortDirective)
    .directive("setColour", SetColourDirective)
    .directive("noAnimate", NoAnimateDirective)
    .directive("customSort", CustomSortDirective)
    .directive("userName", UserNameDirective)
    .directive("shiftEnter", ShiftEnterDirective)
    .directive("filteredList", FilteredListDirective)
    .directive("pageHeader", PageHeaderDirective)
    .directive("subHeader", SubHeaderDirective)
    .directive("subSubHeader", SubSubHeaderDirective)
    .directive("modalHeader", ModalHeaderDirective)
    .directive("modalContent", ModalContentDirective)
    .directive("modalFooter", ModalFooterDirective)
    .directive("modal", ModalDirective);